import DocumentWatermarkIcon from '@material-ui/icons/BrandingWatermark';
import DocumentWatermarkList from './DocumentWatermarkList';
import DocumentWatermarkCreate from './DocumentWatermarkCreate';
import DocumentWatermarkEdit from './DocumentWatermarkEdit';

export default {
  list: DocumentWatermarkList,
  create: DocumentWatermarkCreate,
  edit: DocumentWatermarkEdit,
  icon: DocumentWatermarkIcon
};
